import gql from 'graphql-tag';

export default gql`
  subscription subscribeToNewMessage($conversationId: ID!) {
    subscribeToNewMessage(conversationId: $conversationId) {
      __typename
      conversationId
      attachment {
        key
        type
        size
        name
      }
      createdAt
      id
      sender
      content
      isSent
      isRead
      isQuestion
    }
  }
`;
